const unitToMinutes = {
  minutes: 1,
  hours: 60,
  days: 1440,
  weeks: 10080,
  months: 43200,
  years: 525600,
};

export const delayToMinutes = (delay) => {
  if (!delay?.value || !delay?.delayUnit) return 0;
  const factor = unitToMinutes?.[delay.delayUnit] || 0;
  return delay.value * factor;
};

export const calculateTotalDelay = (actions, index) => {
  let sum = 0;
  for (let i = 0; i <= index; i++) {
    const delay = actions?.[i]?.delay;
    sum += delayToMinutes(delay);
  }
  return sum;
};

export const getInheritedDelay = (actions, index) => {
  if (index === 0) return 0;
  return calculateTotalDelay(actions, index - 1);
};

export const hasDelayAbove = (actions, index) => {
  for (let i = 0; i < index; i++) {
    const delay = actions?.[i]?.delay;
    if (delay?.show && delay?.value > 0) {
      return true;
    }
  }
  return false;
};

export const hasOwnDelay = (action) => {
  return Boolean(action?.delay?.show);
};
